module.exports = __webpack_public_path__ + "static/media/passport status 1-01.a7c38f4f.svg";